import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import logoImg from '../../../../assets/images/logo.png';

import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { NamedLink, Button, IconCollection, } from '../../../../components';

import css from './SideBar.module.css';
import { PRIMARY_RULEBOOK_GROUP_ID, MY_FAVOURITE, RECENT_CHATS } from '../../../../util/types';
import { capitalizeWords } from '../../../../util/data';
import { v4 as uuidv4 } from 'uuid';

const SideBar = (props) => {
  const [gptSections, setGptSection] = useState([MY_FAVOURITE, RECENT_CHATS]);
  const [openDropDwon, setOpenDropDwon] = useState([]);
  const {
    isOpen,
    onClose,
    FeedTabComponent,
    chatDetails,
    userFavChatDetails,
    scrollToSection,
    currentUser
  } = props;

  const { favGpt = [], gpts = [] } = userFavChatDetails || {};
  const favFileIds = favGpt?.map((chat) => chat.rulebook_id) || [];
  const favChats = gpts?.filter((e) => favFileIds?.includes(e.rulebook_id)) || [];

  useEffect(() => {
    // Disable background scroll when sidebar is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const toggleFunction = (selectedSection) => {
    setGptSection(prev =>
      prev.includes(selectedSection)
        ? prev.filter(item => item !== selectedSection)  // Remove if exists
        : [...prev, selectedSection]                    // Add if not exists
    );
  };

  return (
    <>
      <div className={`${css.overlay} ${isOpen ? css.overlayVisible : ''}`} onClick={onClose}></div>
      <div className={`${css.sideBar} ${isOpen ? css.open : ''}`}>
        <button className={css.closeButton} onClick={onClose}>
          <ProfileIconCard type="cross" />
        </button>
        <div className={classNames(css.content, css.mobileContent)}>
          <img src={logoImg} />
          {FeedTabComponent}
        </div>
        <div>
          <NamedLink name="RuleBooksSearchPage" params={{ rulebookId: 'all' }}>
            <div className={css.content}>
              <span className={css.icon}>
                <IconCollection name="ruleBookIcon" />
              </span>
              <FormattedMessage id="ChatBotSideBar.rulebooks" />
            </div>
          </NamedLink>
          <NamedLink name="FavouritePage" params={{ rulebookId: 'favourites' }}>
            <div className={css.content}>
              <span className={css.icon}>
                <IconCollection name="myFavouriteIcon" />
              </span>
              <FormattedMessage id="ChatBotSideBar.myFavourites" />
            </div>
          </NamedLink>
          <NamedLink name="AiChatBotRulebookPage" params={{ rulebookId: PRIMARY_RULEBOOK_GROUP_ID || "1111", sessionId: uuidv4() }} className={css.activeLink}>
            <div className={css.content}>
              <span className={css.icon}>
                <ProfileIconCard type="feed" />
              </span>
              <FormattedMessage id="ChatBotSideBar.generalChat" />

            </div>
          </NamedLink>
          <div className={css.buttonContainer}>
            <Button className={css.requestButton} onClick={(e) => { scrollToSection(e), onClose() }} disabled={!(currentUser && currentUser.id)}><FormattedMessage id="ChatBotSideBar.requestRuleBook" /></Button>

          </div>

          {(favChats && favChats.length > 0) ?
            <div className={css.favChatsContainer}>
              <>
                <span onClick={() => toggleFunction(MY_FAVOURITE)}
                  className={css.sectionTitle}
                >
                  <FormattedMessage id="ChatBotSideBar.myFavouritesSection" />
                  {gptSections.includes(MY_FAVOURITE) ? <span className={css.sectionCount}>-</span> : <span className={css.sectionCount}>+</span>}
                </span>
                {gptSections.includes(MY_FAVOURITE) ? <ul className={css.sectionContent}>
                  {favChats?.map((gpt) => {
                    return (
                      <div>
                        <li onClick={() => {
                          setOpenDropDwon(prev =>
                            prev.includes(gpt?.rulebook_name)
                              ? prev.filter(item => item !== gpt?.rulebook_name)  // Remove if exists
                              : [...prev, gpt?.rulebook_name]                    // Add if not exists
                          );
                        }}>
                          <IconCollection name={"roundIcon"} />
                          <div className={css.arrowIconWrapper}>
                            {capitalizeWords(gpt?.rulebook_name)}
                            {openDropDwon.includes(gpt?.rulebook_name) ? <IconCollection name={"downColorArrowIcon"} /> : <IconCollection name={"downArrowIcon"} />}</div>
                        </li>
                        {openDropDwon.includes(gpt?.rulebook_name) ? <div className={css.sectionSubContent}>
                          <NamedLink name="AiChatBotRulebookPage" params={{ rulebookId: gpt?.rulebook_id || "1111", sessionId: uuidv4() }}>
                            <><span className={css.dot}></span><FormattedMessage id="ChatBotSideBar.startChat" /></>
                          </NamedLink>
                          {(chatDetails.filter((e) => e.rulebook_id == gpt?.rulebook_id) && chatDetails.filter((e) => e.rulebook_id == gpt?.rulebook_id).length > 0) ?
                            <>
                              {Object.entries(
                                chatDetails.filter((e) => e.rulebook_id == gpt?.rulebook_id).reduce((acc, chat) => {
                                  if (!acc[chat.session_id]) acc[chat.session_id] = [];
                                  acc[chat.session_id].push(chat);
                                  return acc;
                                }, {})
                              )
                                .slice(-2) // Keep only the last 3 recent chats
                                .reverse()
                                .map(([sessionId, chats]) => (
                                  <NamedLink
                                    key={sessionId}
                                    name="AiChatBotRulebookPage"
                                    params={{ rulebookId: chats[0]?.rulebook_id || "1111", sessionId:sessionId || "1111" }}
                                  >
                                    <><span className={css.dot}></span>
                                      {chats[0]?.query}
                                    </>
                                  </NamedLink>
                                ))}
                            </> : null}
                        </div> : null}
                      </div>
                    )
                  })}
                </ul> : null}
              </>

            </div>
            : null
          }

          {(chatDetails && chatDetails.length > 0) ? (
            <div>
              <>
                <span
                  onClick={() => toggleFunction(RECENT_CHATS)}
                  className={css.sectionTitle}
                >
                  <FormattedMessage id="ChatBotSideBar.recentChats" />
                  {gptSections.includes(RECENT_CHATS) ? (
                    <span className={css.sectionCount}>-</span>
                  ) : (
                    <span className={css.sectionCount}>+</span>
                  )}
                </span>

                {gptSections.includes(RECENT_CHATS) ? (
                  <ul className={css.sectionContent}>
                    {/* Group chats by session_id */}
                    {Object.entries(
                      chatDetails.reduce((acc, chat) => {
                        if (!acc[chat.session_id]) acc[chat.session_id] = [];
                        acc[chat.session_id].push(chat);
                        return acc;
                      }, {})
                    )
                      .slice(-3) // Keep only the last 3 recent chats
                      .reverse()
                      .map(([sessionId, chats]) => (
                        <NamedLink
                          key={sessionId}
                          name="AiChatBotRulebookPage"
                          params={{ rulebookId: chats[0]?.rulebook_id || "1111", sessionId:sessionId || "1111" }}
                        >
                          <li>
                            <IconCollection name={"recentRoundIcon"} />
                            {chats[0]?.query}
                          </li>
                        </NamedLink>
                      ))}
                  </ul>
                ) : null}
              </>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default SideBar;
